import StandardLayout from './StandardLayoutRebrand';

export default StandardLayout;
